import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const textBox = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    fixedPosition: z.boolean().nullable().optional().describe('Fixed Position'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Sequence - Display order'),

    positionX: z.number().nullable().optional().hidden().describe('Position X'),

    positionY: z.number().nullable().optional().hidden().describe('Position Y'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    resourceId: z.number().hidden().describe('Foreign key to Resource'),

    resource: belongsTo('Resource'),
  })
  .describe('A positioned block of text within a resource.')
  .as('TextBox');

export { textBox as textBoxSchema };
